import { LayoutDashboard, Circle, Mic, CalendarDays, Network, Settings, Home, LayoutGrid, UserCheck } from "lucide-react";

export const navItems = [
  { key: "dashboard", label: "Dashboard", icon: Home, route: "/" },
  { key: "loops", label: "Loops", icon: Circle, route: "/loops" },
  { key: "recordings", label: "Recordings", icon: Mic, route: "/recordings" },
  { key: "calendar", label: "Calendar", icon: CalendarDays, route: "/calendar" },
  { key: "network", label: "Network", icon: Network, route: "/network" },
  { key: "settings", label: "Settings", icon: Settings, route: "/settings" },
];

export const adminNavItems = [
  { key: "admin-usage", label: "Usage", icon: LayoutGrid, route: "/admin/usage", isAdmin: true },
  { key: "admin-overview", label: "Overview", icon: LayoutGrid, route: "/admin/overview", end: true, isAdmin: true },
  { key: "admin-users", label: "Users", icon: UserCheck, route: "/admin/users", end: true, isAdmin: true },
];
